 
import _ from 'underscore'
import service from '../service/group'
import CONSTANT from '../constant/group'

export default {
  getActList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getActList(data).then(info => {
        resolve(info)
      }, e => {
        reject(e)
      })
    })
  },
  getGroupInfo({
    commit
  }, {
    productId
  }) {
    return new Promise((resolve, reject) => {
      return service.getGroupInfo(productId).then(info => {
        commit(CONSTANT.ITEM_GET_GROUP_INFO_SUCCESS, info)
        resolve(info)
      }, e => {
        commit(CONSTANT.ITEM_GET_GROUP_INFO_ERROR, e)
        reject(e)
      })
    })
  },

  getHotActiveGroupList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getHotActiveGroupList(data).then(info => {
        commit(CONSTANT.ITEM_GET_HOT_ACTIVE_GROUP_LIST_SUCCESS, info)
        resolve(info)
      }, e => {
        commit(CONSTANT.ITEM_GET_HOT_ACTIVE_GROUP_LIST_ERROR, e)
        reject(e)
      })
    })
  },

  getMoreGroup({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getMoreGroup(data).then(data => {
        commit(CONSTANT.ITEM_GETMOREGROUP_SUCCESS, data)
        return resolve(data)
      }, e => {
        reject(e)
        commit(CONSTANT.ITEM_GETMOREGROUP_ERROR, e)
      })
    })
  },

  getGroupUser({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getGroupUser(data).then(data => {
        commit(CONSTANT.ITEM_GET_GROUP_USER_SUCCESS, data)
        return resolve(data)
      }, e => {
        reject(e)
        commit(CONSTANT.ITEM_GET_GROUP_USER_ERROR, e)
      })
    })
  },

  getBubbleList({
    commit
  }, data) {
    return new Promise((resolve, reject) => {
      return service.getBubbleList(data).then(data => {
        return resolve(data)
      }, e => {
        reject(e)
      })
    })
  }
}
